<div class="content__inner">
    <header class="content__title">
        <h1>{{ "firmwares.list.title" | translate }}</h1>
        <small>{{ "firmwares.list.subtitle" | translate }}</small>

        <div class="actions">
            <button *appHasPermission="'FIRMWARES.ADD'" (click)="addFirmware()" class="btn btn-success btn--icon-text" style="margin-left: 25px"><i class="zmdi zmdi-collection-plus"></i> {{ "firmwares.list.add" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'FIRMWARES.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "firmwares.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "firmwares.props.name" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="originalname">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "firmwares.props.originalname" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.originalname }}</td>
                    </ng-container>

                    <ng-container matColumnDef="productType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "firmwares.props.productType" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.productType }}</td>
                    </ng-container>

                    <ng-container matColumnDef="published">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "firmwares.props.published" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.published }}</td>
                    </ng-container>

                    <ng-container matColumnDef="publishedBeta">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "firmwares.props.publishedBeta" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.publishedBeta }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "firmwares.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "firmwares.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end">
                                <i (click)="editFirmware(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'FIRMWARES.EDIT'"></i>
                                <i (click)="deleteFirmware(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'FIRMWARES.DELETE'"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
